import api from './apiClient'

/**
 * Servicio para gestión de emergencias
 */
export const emergenciasService = {
  // Obtener todas las emergencias
  getAll: async () => {
    try {
      const response = await api.get('/emergencias')
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al obtener emergencias' 
      }
    }
  },

  // Obtener emergencias activas
  getActive: async () => {
    try {
      const response = await api.get('/emergencias/activas')
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al obtener emergencias activas' 
      }
    }
  },

  // Obtener emergencia por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/emergencias/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al obtener emergencia' 
      }
    }
  },

  // Crear nueva emergencia
  create: async (emergencyData) => {
    try {
      const response = await api.post('/emergencias', emergencyData)
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al crear emergencia' 
      }
    }
  },

  // Actualizar estado de emergencia
  updateStatus: async (id, status) => {
    try {
      const response = await api.patch(`/emergencias/${id}/estado`, { estado: status })
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al actualizar estado' 
      }
    }
  },

  // Asignar unidad medica aemergencia
  assignMedicalUnit: async (emergencyId, medicalUnitId) => {
    try {
      const response = await api.post(`/emergencias/${emergencyId}/asignar`, { 
        id_unidad_medica: medicalUnitId 
      })
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al asignar unidad medica' 
      }
    }
  },

  // Confirmar llegada a emergencia
  confirmArrival: async (emergencyId) => {
    try {
      const response = await api.patch(`/emergencias/${emergencyId}/confirmar_llegada`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al confirmar llegada'
      }
    }
  },

  // Completar emergencia
  complete: async (id, completionData) => {
    try {
      const response = await api.post(`/emergencias/${id}/completar`, completionData)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al completar emergencia'
      }
    }
  },

  // Cancelar emergencia
  cancel: async (id, reason) => {
    try {
      const response = await api.post(`/emergencias/${id}/cancelar`, { motivo: reason })
      return { success: true, data: response.data }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al cancelar emergencia' 
      }
    }
  },

  // Obtener historial de emergencias de un usuario
  getUserHistory: async (userId) => {
    try {
      const response = await api.get(`/emergencias/usuario/${userId}`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener historial'
      }
    }
  },

  // Obtener emergencia activa del usuario logueado
  getActiveEmergency: async () => {
    try {
      const response = await api.get('/emergencias/emergencia_activa')
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al obtener emergencia activa'
      }
    }
  },

  // Obtener mis emergencias (del usuario autenticado)
  getMyEmergencies: async () => {
    try {
      const response = await api.get('/emergencias/mis_emergencias')
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al obtener mis emergencias'
      }
    }
  },

  // Simular emergencia (para pruebas del conductor)
  simulate: async () => {
    try {
      const response = await api.post('/emergencias/simular')
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al simular emergencia'
      }
    }
  },

  // Confirmar llegada a emergencia
  confirmArrival: async (id) => {
    try {
      const response = await api.patch(`/emergencias/${id}/confirmar_llegada`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al confirmar llegada'
      }
    }
  },

  // Completar emergencia (usando ruta correcta con guión bajo)
  completeEmergency: async (id) => {
    try {
      const response = await api.patch(`/emergencias/${id}/completar`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al completar emergencia'
      }
    }
  },

  // Completar emergencia con liberación de unidad médica (nuevo endpoint completo)
  completeEmergencyWithRelease: async (id, completionData) => {
    try {
      const response = await api.post(`/emergencias/${id}/completar_con_liberacion`, {
        diagnostico_medico: completionData.medicalDiagnosis,
        clasificacion_servicio: completionData.serviceClassification,
        justificacion_clasificacion: completionData.classificationJustification,
        tratamiento_aplicado: completionData.treatmentApplied,
        observaciones_adicionales: completionData.additionalObservations,
        medicamentos: completionData.medicamentos || []
      })
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al completar emergencia con liberación'
      }
    }
  },

  // Asignar unidad medica (usando ruta correcta con guión bajo)
  assignMedicalUnitToEmergency: async (emergencyId, medicalUnitId) => {
    try {
      const response = await api.patch(`/emergencias/${emergencyId}/asignar_unidad_medica`, {
        id_unidad_medica: medicalUnitId
      })
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al asignar unidad medica'
      }
    }
  },

  // Obtener emergencias asignadas a una unidad médica específica
  getEmergenciesByMedicalUnit: async (medicalUnitId) => {
    try {
      const response = await api.get(`/emergencias_unidades_medicas/unidad_medica/${medicalUnitId}`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al obtener emergencias de la unidad médica'
      }
    }
  },

  // Obtener emergencia activa asignada a una unidad médica (la primera activa)
  getActiveMedicalUnitEmergency: async (medicalUnitId) => {
    try {
      const response = await api.get(`/emergencias_unidades_medicas/unidad_medica/${medicalUnitId}`)

      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        // Buscar la primera asignación activa
        const activeAssignment = response.data.find(assignment =>
          assignment.activo === true && !assignment.fecha_liberacion
        )

        if (activeAssignment && activeAssignment.id_emergencia) {
          // Obtener los detalles completos de la emergencia
          const emergencyResponse = await api.get(`/emergencias/${activeAssignment.id_emergencia}`)
          return {
            success: true,
            data: emergencyResponse.data,
            assignment: activeAssignment
          }
        }
      }

      return { success: true, data: null }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al obtener emergencia activa de la unidad médica'
      }
    }
  },

  // Obtener emergencias completadas por unidad médica
  getCompletedEmergenciesByUnit: async (medicalUnitId) => {
    try {
      const response = await api.get(`/emergencias/completadas/unidad/${medicalUnitId}`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al obtener emergencias completadas'
      }
    }
  },

  // Obtener emergencias completadas sin encuesta respondida (usuario actual)
  getCompletedWithoutSurvey: async () => {
    try {
      const response = await api.get('/emergencias/completadas_sin_encuesta')
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.mensaje || 'Error al obtener emergencias sin encuesta'
      }
    }
  }
}

export default emergenciasService